/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Scim_Token_Created_DescInputs */



/**
* | output |
* | --- |
* | "A SCIM token was issued, so the connected identity provider can now create and deactivate members." |
*
* @param {Audit_Details_Scim_Token_Created_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_scim_token_created_desc = /** @type {((inputs?: Audit_Details_Scim_Token_Created_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Scim_Token_Created_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein SCIM-Token wurde ausgestellt. Der angebundene Identitätsanbieter kann jetzt Mitglieder anlegen und deaktivieren.")
	return /** @type {LocalizedString} */ ("A SCIM token was issued, so the connected identity provider can now create and deactivate members.")
});